import React, { useState } from "react";
import { colors } from "utils/styles";
import DynamicLink from "@components/Reusables/DynamicLink";
import useMembershipStatus from "hooks/useMembershipStatus";
import Content from "@components/Reusables/Content";
import { resolveColor } from "utils/styles";
export default function NotificationDialog(props) {
	const { notificationDialogue } = props;
	const membershipStatus = useMembershipStatus();

	const nd = notificationDialogue?.fields;
	const bgColor = resolveColor(nd?.contentBackgroundColor);
	const color = resolveColor(nd?.color);
	return (
		<>
			{notificationDialogue && (
				<dialog open className="announcement-bar sticky-top p-2">
					<Content content={notificationDialogue} />
				</dialog>
			)}

			<MemberRenewalNotification membershipStatus={membershipStatus} />

			<style jsx>{`
				.announcement-bar {
					position: static;
					top: 0;
					width: 100%;
					background: ${bgColor};
					color: ${color};
				}
			`}</style>
		</>
	);
}

function MemberRenewalNotification(props) {
	const membershipStatus = props.membershipStatus;
	const { requiresWebsiteBanner, membershipExpireingMessage } = membershipStatus;

	if (!membershipExpireingMessage) {
		return <></>;
	}

	return (
		<dialog open className="member-renew sticky-top">
			<DynamicLink href={`${process.env.APP_URL}/membership`}>
				{/* <span>{message}</span> */}
				<span>{membershipExpireingMessage}</span>
			</DynamicLink>

			<style jsx>{`
				.member-renew {
					font-size: 14px;
					line-height: 28px;

					top: 0;
					width: 100%;
					background: ${colors.red};
					color: ${colors.white};
					justify-content: center;
					align-items: center;
					display: block;
					padding: 0 1em;
					text-align: center;
					font-weight: bold;
				}
			`}</style>
		</dialog>
	);
}
